export default __webpack_public_path__ + "static/media/logo2.1263bfd7.png";